<script>
import { mapGetters } from 'vuex'

import LavenderMixin from '@/mixins/lavender'
import LoaderPerformanceGateMixin from '@/mixins/loader-performance-gate'

import ToastItem from './toast-item.vue'

const TOAST_OVERLAY_ID = 'toast-overlay'

export default {
  name: 'SingleCheckoutToast',
  mixins: [LavenderMixin, LoaderPerformanceGateMixin],
  components: { ToastItem },
  computed: {
    ...mapGetters('toast', ['toastMessages', 'hasOverlay']),
    toastsTotal() {
      return this.toastMessages.length
    },
    isLavenderEnabled() {
      return this.isLavenderReskinEnabled
    },
    toastContainerClass() {
      return [
        'toast-container',
        { 'toast-container_lavender': this.isLavenderReskinEnabled },
      ]
    },
  },
  watch: {
    toastsTotal(value) {
      const overlay = document.getElementById(TOAST_OVERLAY_ID)

      if (this.hasOverlay && overlay && value) {
        if (this.isEnabledLoaderPerformanceGate) {
          overlay.style.display = 'none'
        } else {
          overlay.style.display = 'block'
        }
        return
      }

      overlay.style.display = 'none'
    },
  },
  created() {
    if (!document.getElementById(TOAST_OVERLAY_ID)) {
      const elemDiv = document.createElement('div')
      elemDiv.setAttribute('id', TOAST_OVERLAY_ID)
      elemDiv.className = 'toast-wrapper__overlay'
      document.body.appendChild(elemDiv)
    }
  },
}
</script>

<template>
  <div :class="toastContainerClass">
    <v-slide-y-transition group>
      <ToastItem
        v-for="toastMessage in toastMessages"
        :key="toastMessage.id"
        :data="toastMessage"
        :options="toastMessage.options ?? {}"
      />
    </v-slide-y-transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/responsive.scss';

.toast-container {
  position: fixed;
  left: auto;
  right: auto;
  width: 100%;
  z-index: 99999;
  top: 19px;
}

.toast-container_lavender {
  top: 6px;
}

@include for-sm-up {
  .toast-container {
    top: 88px;
  }
}
</style>

<style lang="scss">
.toast-wrapper__overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff80;
  z-index: 9999;
  display: none;
}
</style>
